import { Box } from '@mui/material';
import FlexBox from 'Components/FlexBox';
import { ThemeTypography } from 'DesignSystem';
import RiskLevelBadge from 'DesignSystem/DataDisplay/RiskLevelBadge/RiskLevelBadge';
import Icon from 'DesignSystem/Primitives/Icon/Icon';
import React, { FC } from 'react';
import {
  EQuestionnaireRiskLevel,
  TQuestionnaireRiskLevel,
} from 'FeatureModules/Questionnaire/types/questionnaire.types';

interface IQuestionnaireTitleProps {
  title: string;
  externalId?: string;
  year: number;
  riskLevel?: TQuestionnaireRiskLevel;
  partnerName?: string;
}

const QuestionnaireTitle: FC<IQuestionnaireTitleProps> = ({
  title,
  year,
  externalId,
  riskLevel,
  partnerName,
}) => {
  return (
    <FlexBox width="100%" gap={2}>
      <Icon name="document" size="xx-large" />

      <Box width="calc(100% - 60px)">
        <FlexBox gap={1}>
          <ThemeTypography variant="ITEM_TITLE" autoOverflow>
            {title}
          </ThemeTypography>
          {externalId && (
            <Box maxWidth="30%">
              <ThemeTypography variant="BODY_MEDIUM" autoOverflow color="GRAY_80">
                | {externalId}
              </ThemeTypography>
            </Box>
          )}
          {riskLevel && riskLevel !== EQuestionnaireRiskLevel.PENDING && (
            <RiskLevelBadge riskLevel={riskLevel} />
          )}
        </FlexBox>

        <FlexBox gap={1} overflow="hidden">
          <FlexBox gap={0.5}>
            <Icon name="tag-filled" size="small" color="gray-60" />
            <ThemeTypography variant="BODY_SMALL" color="GRAY_80" autoOverflow>
              Supplier self-assessment
            </ThemeTypography>
          </FlexBox>

          <FlexBox gap={0.5}>
            <Icon name="calendar" size="small" color="gray-60" />
            <ThemeTypography variant="BODY_SMALL" color="GRAY_80" autoOverflow>
              {year}
            </ThemeTypography>
          </FlexBox>

          {partnerName && (
            <FlexBox gap={0.5}>
              <Icon name="tag-filled" size="small" color="gray-60" />
              <ThemeTypography variant="BODY_SMALL" color="GRAY_80" autoOverflow>
                {partnerName}
              </ThemeTypography>
            </FlexBox>
          )}
        </FlexBox>
      </Box>
    </FlexBox>
  );
};

export default QuestionnaireTitle;
